<template>
    <b-container fluid class="px-1 px-md-4">
        <h5 class="mt-4 p-2 text-center text-primary text-uppercase">Transacciones Pendientes</h5>
        <b-tabs justified>
            <b-tab title-item-class="font-weight-bold" title="COBRAR">
                <b-row class="mx-n2 mx-sm-0 justify-content-center">
                    <b-col cols="12" class="mt-4 mb-2">
                        <b-form-group class="mb-0">
                            <b-input-group size="sm">
                                <b-input-group-prepend>
                                    <b-button variant="default" class="m-0 btrr-0 bbrr-0 px-4" v-b-modal.qrReader>
                                        <i class="material-icons mdi mdi-qrcode-scan"></i>
                                    </b-button>
                                </b-input-group-prepend>

                                <b-form-input id="search" v-model="buy.search" type="search" placeholder="Buscar" class="pad-3-15"></b-form-input>

                                <b-input-group-append>
                                    <b-button variant="default" :disabled="!buy.search" @click="buy.search = ''" class="m-0 btlr-0 bblr-0 px-2">
                                        <i class="material-icons mdi mdi-close"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <!-- Modal QR Reader -->
                        <b-modal
                            id="qrReader"
                            centered
                            no-fade
                            header-class="text-center"
                            header-bg-variant="primary"
                            header-text-variant="light"
                            header-close-variant="light"
                            footer-class="border-0"
                            hide-footer
                            body-class="text-center px-4 my-4"
                            title="Lector de QR"
                            tabindex="-1"
                            role="dialog"
                            aria-hidden="true">
                            <b-row align-h="center">
                                <b-col cols="12" align-self="center">
                                    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                                        <div v-if="qrReaderLoading" class="loading-indicator m-3">
                                            Iniciando Cámara ...
                                        </div>
                                        <div v-if="validationSuccess" class="validation-success">
                                            <img :src="checkIcon" alt="Checkmark"/>
                                            El QR ha sido verificado exitosamente!
                                        </div>
                                        <div v-if="validationFailure" class="validation-failure">
                                            <img :src="uncheckIcon" alt="Xmark"/>
                                            La verificación del QR ha fallado!
                                        </div>
                                        <div v-if="validationPending" class="validation-pending">
                                            <img :src="loadIcon" alt="Synchronization"/>
                                            Verificación de QR en progreso...
                                        </div>
                                    </qrcode-stream>
                                    <b-form-input
                                        v-show="false"
                                        name="qrReader"
                                        v-model="result"
                                        type="text"
                                        class="text-center"
                                        v-validate="'required:true'"
                                        :state="validateState('qrReader')"
                                        :data-vv-as="(labels.code).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="qrReader-live-feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="qrReader-live-feedback">{{
                                            veeErrors.first('qrReader')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-col>
                            </b-row>
                        </b-modal>
                    </b-col>
                    <b-col cols="12">
                        <b-table
                            :items="buy.items"
                            :fields="buy.fields"
                            responsive="sm"
                            class="my-2 border-bottom"
                            stacked="sm"
                            hover
                            small
                            show-empty
                            no-border-collapse
                            table-variant="light"
                            details-td-class="px-0"
                            empty-filtered-text="No hay cobros que coincidan con la búsqueda"
                            empty-text="No hay cobros pendientes para mostrar"
                            :current-page="buy.currentPage"
                            :per-page="perPage"
                            :filter="buy.search"
                            :busy="isBusy"
                            @filtered="onFiltered">
                            <template #cell(actions)="row">
                                <b-button variant="default" size="sm" title="Cobrar" @click="openSale(row.item.id)" v-b-modal.sale>
                                    <i class="material-icons">point_of_sale</i>
                                </b-button>
                                <b-button class="text-white" variant="info" size="sm" :to="'/partner/account/history/details/' + row.item.id">
                                    <i class="material-icons">info</i>
                                </b-button>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-4">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Actualizando...</strong>
                                </div>
                            </template>
                        </b-table>

                        <!-- Modal Form Sale -->
                        <b-modal
                            id="sale"
                            centered
                            header-class="text-center"
                            header-bg-variant="primary"
                            header-text-variant="light"
                            header-close-variant="light"
                            footer-class="border-0"
                            hide-footer
                            body-class="text-center px-4 my-4"
                            :title="'Cobrar Transacción (ID: ' + form.id + ')'"
                            tabindex="-1"
                            role="dialog"
                            size="lg"
                            aria-hidden="true">
                            <b-form id="formSale" @submit.stop.prevent="getApprove(form.id)">
                                <b-row class="justify-content-center">
                                    <b-col cols="12" md="10" align-self="start" class="pb-3">
                                        <h6>Nombre</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.sname }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Documento</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.sdocument }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Telefono</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.sender.mobile }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Valor a Cobrar</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.amount_send_text }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Tipo de Moneda</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.currency_send }}</h4>
                                    </b-col>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-col cols="12" md=8 align-self="start">
                                        <b-form-group :label="labels.amount+':'">
                                            <b-input-group>
                                                <template #prepend>
                                                    <b-input-group-text class="m-0 px-sm-4 btrr-0 bbrr-0"><b>{{ payment.currency_send === 'PEN' ? 'S/.' : '$' }}</b></b-input-group-text>
                                                </template>
                                                <currency-input
                                                    v-model="form.amount"
                                                    name="amount"
                                                    v-validate="'required:true'"
                                                    :state="validateState('amount')"
                                                    aria-describedby="amount-live-feedback"
                                                    :data-vv-as="(labels.amount).toLowerCase()"
                                                    :disabled="loading"
                                                    :precision="currency_precision"
                                                    class="text-right text-sm-center form-control form-control-lg"
                                                    style="padding: 0.5rem 1rem; background-image: none;"/>
                                                <template #append>
                                                    <b-input-group-text class="m-0 px-sm-4 btlr-0 bblr-0"><b>{{ payment.currency_send }}</b></b-input-group-text>
                                                </template>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="amount-live-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="10" align-self="start">
                                        <h4 :class="form.amount < payment.amount_send ? 'text-danger' : 'text-success'">Cambio: {{ (form.amount - payment.amount_send).toLocaleString('en-US') }} {{ payment.currency_send }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="10" align-self="start" class="my-4">
                                        <b-button variant="info" size="lg" pill class="shadow px-5" title="Imprimir" @click="print('ticket1')">
                                            <i class="material-icons">print</i> <span>Imprimir</span>
                                        </b-button>
                                        <b-button type="submit" variant="default" size="lg" pill class="shadow al px-5"
                                                  form="formSale" :disabled="loading || form.amount < payment.amount_send">
                                            <b-spinner small type="grow" v-if="loading"></b-spinner>
                                            <b-icon icon="patch-check" aria-hidden="true" v-else></b-icon>
                                            &nbsp;&nbsp;<span>{{ loading ? 'Aprobando...' : 'Aprobar' }}</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <div id="ticket1" style="width: 280px; max-width: 280px; font-size: 14px; margin: 0;">
                                    <div style="width: 280px; margin: 0; text-align: center;">
                                        <img :src="'/' + (partner && partner.logo && !payment.user_id ? partner.logo : 'img/logo_header.png')"
                                             alt="logo partner" title="Logo Partner" style="max-width: 220px; padding-bottom: 12px;"/>
                                    </div>
                                    <p style="font-family: 'Trebuchet MS', Helvetica, sans-serif; text-align: center; width: 280px; margin: 0;">
                                        <strong><u>TICKET #{{ (payment.id).toString().padStart(6, 0) }}</u></strong>
                                        <br><br>
                                        <span v-if="partner">{{partner.name}}</span>
                                        <br v-if="partner">
                                        <span v-if="partner">{{ partner.address + ' - ' }}{{ partner.city + ', ' }}{{ partner.country }}</span>
                                        <br v-if="partner"><br v-if="partner">
                                        <span style="text-transform: capitalize;">Cajero: {{ user.name ? (user.name).toLowerCase() : '' }}{{ user.lname ? ' ' + ((user.lname).replace(/,/g, '')).toLowerCase() : '' }}</span>
                                        <br>
                                        <span>{{ new Date() | moment("DD/MM/YYYY hh:mm:ss A") }}</span>
                                        <br><br>
                                        <strong v-if="payment.pin !== null && payment.country_receiver === 'CO' && (payment.pin).includes('-')"><u>Convenio: {{ ((payment.pin).split('-'))[0] }}</u></strong>
                                        <br v-if="payment.pin !== null && payment.country_receiver === 'CO' && (payment.pin).includes('-')">
                                        <strong><u>PIN: {{ payment.pin !== null && payment.country_receiver === 'CO' && (payment.pin).includes('-') ? ((payment.pin).split('-'))[1] : payment.pin }}</u></strong>
                                        <br><br>
                                        <span>Valor Recibido: <strong>{{ payment.amount_send_text + ' ' + payment.currency_send }}</strong></span>
                                        <br>
                                        <span>Comisión: <strong>{{ payment.fee_text + ' ' + payment.currency_send }}</strong></span>
                                        <br><br>
                                        <span>Válido por 30 Días</span>
                                        <br><br>
                                    </p>
                                    <table style="font-family: 'Trebuchet MS', Helvetica, sans-serif; margin: 0; border-top: 1px solid black; border-collapse: collapse;">
                                        <thead>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th style="width: 120px; max-width: 120px;">Beneficiario</th>
                                            <th style="width: 160px; max-width: 160px; text-transform: capitalize;">{{ payment.rname ? (payment.rname).toLowerCase() : '' }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.rdocument !== null">
                                            <td style="width: 120px; max-width: 120px;">Documento</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.rdocument }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.bank_info !== null">
                                            <td style="width: 120px; max-width: 120px;">Banco</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.bank_info.name }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.receiver.tc !== null">
                                            <td style="width: 120px; max-width: 120px;">Tipo de Cuenta</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.receiver.tc }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.receiver.nc !== null">
                                            <td style="width: 120px; max-width: 120px;">Número de Cuenta</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.receiver.nc }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.office_info !== null">
                                            <td style="width: 120px; max-width: 120px;">Oficina</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.office_info.payer + ' - ' + payment.office_info.name }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.office_info !== null">
                                            <td style="width: 120px; max-width: 120px;">Dirección</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.office_info.address + ' - ' + payment.office_info.city }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <td style="width: 120px; max-width: 120px;">Valor Inicial</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.amount_swc + ' ' + payment.currency_send }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.pay_method_text">
                                            <td style="width: 120px; max-width: 120px;">Forma de Pago</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.pay_method_text }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <td style="width: 120px; max-width: 120px;">Tipo de Cambio</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.fx }}</td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th style="width: 120px; max-width: 120px;">Valor a Pagar</th>
                                            <th style="width: 160px; max-width: 160px;">{{ payment.amount_receiver_text + ' ' + payment.currency_receiver }}</th>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th colspan="2"/>
                                        </tr>
                                        </tfoot>
                                    </table>
                                    <br>
                                    <br>
                                    <div style="text-align: center; font-family: 'Trebuchet MS', Helvetica, sans-serif; width: 280px; margin: 0;">
                                        <div style="margin: -2px 0 0; border: 1px solid #333;">
                                            <p style="font-weight: 600; font-size: 16px; margin: 4px 0;">Depositante</p>
                                            <p style="font-size: 16px; margin: 4px 0; text-transform: capitalize;">{{ payment.sname ? (payment.sname).toLowerCase() : '' }}</p>
                                            <p style="margin: -2px 0 8px; font-size: 14px;">{{ payment.sender.email ? (payment.sender.email).toLowerCase() : '' }}</p>
                                            <p style="margin: -2px 0 8px; font-size: 14px;">{{ payment.country_send_text + ' => ' + payment.country_receiver_text }}</p>
                                        </div>
                                        <br>
                                        <br>
                                        <p style="align-content: center; font-size: 16px;">
                                            <b>__________________________</b>
                                            <b>Firma</b>
                                        </p>
                                        <br>
                                        <p style="align-content: center; font-size: 16px;">
                                            <b>¡GRACIAS POR PREFERIRNOS!</b>
                                        </p>
                                        <br>
                                        <br>
                                    </div>
                                </div>
                            </b-form>
                        </b-modal>
                    </b-col>
                    <b-col sm="5" md="6">
                        <b-form-group
                            label="Mostrar:"
                            label-for="per-page-select"
                            label-cols-sm="4"
                            label-cols-md="6"
                            label-cols-lg="9"
                            label-align-sm="right"
                            label-size="sm"
                            class="mt-2 mb-8">
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                                size="sm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="7" md="6">
                        <b-pagination
                            v-model="buy.currentPage"
                            :total-rows="buy.totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="mt-2 mb-8"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title-item-class="font-weight-bold" title="PAGAR">
                <b-row class="mx-n2 mx-sm-0 justify-content-center">
                    <b-col cols="12" class="mt-4 mb-2">
                        <b-form-group class="mb-0">
                            <b-input-group size="sm">
                                <b-form-input id="search" v-model="pay.search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                                <b-input-group-append>
                                    <b-button variant="default" :disabled="!pay.search" @click="pay.search = ''" class="m-0 btlr-0 bblr-0">
                                        <i class="material-icons mdi mdi-close"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-table
                            :items="pay.items"
                            :fields="pay.fields"
                            responsive="sm"
                            class="my-2 border-bottom"
                            stacked="sm"
                            hover
                            small
                            show-empty
                            no-border-collapse
                            table-variant="light"
                            details-td-class="px-0"
                            empty-filtered-text="No hay pagos que coincidan con la búsqueda"
                            empty-text="No hay pagos pendientes para mostrar"
                            :current-page="pay.currentPage"
                            :per-page="perPage"
                            :filter="pay.search"
                            :busy="isBusy"
                            @filtered="onFiltered">
                            <template #cell(actions)="row">
                                <b-button variant="default" size="sm" title="Pagar" @click="openPay(row.item.id)" v-b-modal.pay>
                                    <i class="material-icons">point_of_sale</i>
                                </b-button>
                                <b-button class="text-white" variant="info" size="sm" :to="'/partner/account/history/details/' + row.item.id">
                                    <i class="material-icons">info</i>
                                </b-button>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-4">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Actualizando...</strong>
                                </div>
                            </template>
                        </b-table>

                        <!-- Modal Form Pay -->
                        <b-modal
                            id="pay"
                            centered
                            header-class="text-center"
                            header-bg-variant="primary"
                            header-text-variant="light"
                            header-close-variant="light"
                            footer-class="border-0"
                            hide-footer
                            body-class="text-center px-4 my-4"
                            :title="'Pagar Transacción (ID: ' + form.id + ')'"
                            tabindex="-1"
                            role="dialog"
                            size="lg"
                            aria-hidden="true">
                            <b-form id="formPay" @submit.stop.prevent="getComplete(form.id)">
                                <b-row class="justify-content-center">
                                    <b-col cols="12" md="10" align-self="start" class="pb-3">
                                        <h6>Nombre</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.rname }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Documento</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.rdocument }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Telefono</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.receiver.mobile }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Valor a Pagar</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.amount_receiver_text }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="5" align-self="start" class="pb-3">
                                        <h6>Tipo de Moneda</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.currency_receiver }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="10" align-self="start" class="pb-3">
                                        <h6>Mensaje</h6>
                                        <h4 class="bg-light py-1 px-2 rounded">{{ payment.receiver.details.message1 }}</h4>
                                    </b-col>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-col cols="12" md=8 align-self="start">
                                        <b-form-group :label="labels.amount + ':'">
                                            <b-input-group>
                                                <template #prepend>
                                                    <b-input-group-text class="m-0 px-sm-4 btrr-0 bbrr-0"><b>{{ payment.currency_receiver === 'PEN' ? 'S/.' : '$' }}</b></b-input-group-text>
                                                </template>
                                                <currency-input
                                                    v-model="form.amount"
                                                    name="amount"
                                                    v-validate="'required:true'"
                                                    :state="validateState('amount')"
                                                    aria-describedby="amount-live-feedback"
                                                    :data-vv-as="(labels.amount).toLowerCase()"
                                                    :disabled="loading"
                                                    :precision="currency_precision"
                                                    class="text-right text-sm-center form-control form-control-lg"
                                                    style="padding: 0.5rem 1rem; background-image: none;"/>
                                                <template #append>
                                                    <b-input-group-text class="m-0 px-sm-4 btlr-0 bblr-0"><b>{{ payment.currency_receiver }}</b></b-input-group-text>
                                                </template>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="amount-live-feedback">{{ veeErrors.first('amount') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" md="10" align-self="start">
                                        <h4 :class="form.amount < payment.amount_receiver ? 'text-danger' : 'text-success'">Diferencia: {{ (form.amount - payment.amount_receiver).toLocaleString('en-US') }} {{ payment.currency_receiver }}</h4>
                                    </b-col>
                                    <b-col cols="12" md="10" align-self="start" class="my-4">
                                        <b-button variant="info" size="lg" pill class="shadow px-5" title="Imprimir" @click="print('ticket2')">
                                            <i class="material-icons">print</i> <span>Imprimir</span>
                                        </b-button>
                                        <b-button type="submit" variant="default" size="lg" pill class="shadow al px-5"
                                                  form="formPay" :disabled="loading || form.amount < payment.amount_receiver">
                                            <b-spinner small type="grow" v-if="loading"></b-spinner>
                                            <b-icon icon="patch-check" aria-hidden="true" v-else></b-icon>
                                            &nbsp;&nbsp;<span>{{ loading ? 'Confirmando...' : 'Confirmar' }}</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <div id="ticket2" style="width: 280px; max-width: 280px; font-size: 14px; margin: 0;">
                                    <div style="width: 280px; margin: 0; text-align: center;">
                                        <img :src="'/' + (partner && partner.logo && !payment.user_id ? partner.logo : 'img/logo_header.png')"
                                             alt="logo partner" title="Logo Partner" style="max-width: 220px; padding-bottom: 12px;"/>
                                    </div>
                                    <p style="font-family: 'Trebuchet MS', Helvetica, sans-serif; text-align: center; width: 280px; margin: 0;">
                                        <strong><u>TICKET #{{ (payment.id).toString().padStart(6, 0) }}</u></strong>
                                        <br><br>
                                        <span v-if="partner">{{partner.name}}</span>
                                        <br v-if="partner">
                                        <span v-if="partner">{{ partner.address + ' - ' }}{{ partner.city + ', ' }}{{ partner.country }}</span>
                                        <br v-if="partner"><br v-if="partner">
                                        <span style="text-transform: capitalize;">Cajero: {{ user.name ? (user.name).toLowerCase() : '' }}{{ user.lname ? ' ' + ((user.lname).replace(/,/g, '')).toLowerCase() : '' }}</span>
                                        <br>
                                        <span>{{ new Date() | moment("DD/MM/YYYY hh:mm:ss A") }}</span>
                                        <br><br>
                                        <span>Válido por 30 Días</span>
                                        <br><br>
                                    </p>
                                    <table style="font-family: 'Trebuchet MS', Helvetica, sans-serif; margin: 0; border-top: 1px solid black; border-collapse: collapse;">
                                        <thead>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th style="width: 120px; max-width: 120px;">Beneficiario</th>
                                            <th style="width: 160px; max-width: 160px; text-transform: capitalize;">{{ payment.rname ? (payment.rname).toLowerCase() : '' }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.rdocument !== null">
                                            <td style="width: 120px; max-width: 120px;">Documento</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.rdocument }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <td style="width: 120px; max-width: 120px;">Valor Enviado</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.amount_send_text + ' ' + payment.currency_send }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;" v-if="payment.pay_method_text">
                                            <td style="width: 120px; max-width: 120px;">Forma de Pago</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.pay_method_text }}</td>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <td style="width: 120px; max-width: 120px;">Tipo de Cambio</td>
                                            <td style="width: 160px; max-width: 160px;">{{ payment.fx_rate }}</td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th style="width: 120px; max-width: 120px;">Valor a Pagar</th>
                                            <th style="width: 160px; max-width: 160px;">{{ payment.amount_receiver_text + ' ' + payment.currency_receiver }}</th>
                                        </tr>
                                        <tr style="border-top: 1px solid black; border-collapse: collapse; text-align: left;">
                                            <th colspan="2"/>
                                        </tr>
                                        </tfoot>
                                    </table>
                                    <br>
                                    <br>
                                    <div style="text-align: center; font-family: 'Trebuchet MS', Helvetica, sans-serif; width: 280px; margin: 0;">
                                        <div style="margin: -2px 0 0; border: 1px solid #333;">
                                            <p style="font-weight: 600; font-size: 16px; margin: 4px 0;">Remitente</p>
                                            <p style="font-size: 16px; margin: 4px 0; text-transform: capitalize;">{{ payment.sname ? (payment.sname).toLowerCase() : '' }}</p>
                                            <p style="margin: -2px 0 8px; font-size: 14px;">{{ payment.sdocument }}</p>
                                            <p style="margin: -2px 0 8px; font-size: 14px;">{{ payment.country_send_text + ' ➤ ' + payment.country_receiver_text }}</p>
                                        </div>
                                        <br>
                                        <br>
                                        <p style="align-content: center; font-size: 16px;">
                                            <b>__________________________</b>
                                            <b>Firma</b>
                                        </p>
                                        <br>
                                        <p style="align-content: center; font-size: 16px;">
                                            <b>__________________________</b>
                                            <b>Telefono</b>
                                        </p>
                                        <br>
                                        <p style="align-content: center; font-size: 16px;">
                                            <b>¡GRACIAS POR CONFIAR EN NOSOTROS!</b>
                                        </p>
                                        <br>
                                        <br>
                                    </div>
                                </div>
                            </b-form>
                        </b-modal>
                    </b-col>
                    <b-col sm="5" md="6">
                        <b-form-group
                            label="Mostrar:"
                            label-for="per-page-select"
                            label-cols-sm="4"
                            label-cols-md="6"
                            label-cols-lg="9"
                            label-align-sm="right"
                            label-size="sm"
                            class="mt-2 mb-8">
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                                size="sm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="7" md="6">
                        <b-pagination
                            v-model="pay.currentPage"
                            :total-rows="pay.totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="mt-2 mb-8"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
import axios from "axios";
import {CurrencyInput} from 'vue-currency-input';
import md5 from "md5";

export default {
    name: "Collect",
    props: [ 'user' ],
    components: { CurrencyInput },
    data: () => ({
        isBusy: true,
        buy: {
            search: '',
            fields: [
                {key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right'},
                {key: 'sname', label: 'Cliente', sortable: false},
                {key: 'sdocument', label: 'Documento', sortable: false},
                {key: 'amount_send_text', label: 'Valor', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right'},
                {key: 'currency_send', label: 'Moneda', sortable: false},
                {key: 'date', label: 'Fecha', sortable: false},
                {key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center'}
            ],
            items: [],
            totalRows: 1,
            currentPage: 1,
        },
        pay: {
            search: '',
            fields: [
                {key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right'},
                {key: 'rname', label: 'Destinatario', sortable: false},
                {key: 'rdocument', label: 'Documento', sortable: false},
                {key: 'amount_receiver_text', label: 'Valor', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right'},
                {key: 'currency_receiver', label: 'Moneda', sortable: false},
                {key: 'date', label: 'Fecha', sortable: false},
                {key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center'}
            ],
            items: [],
            totalRows: 1,
            currentPage: 1,
        },
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        camera: 'auto',
        isValid: undefined,
        loadIcon: '/img/synchronization.svg',
        uncheckIcon: '/img/x-mark.svg',
        checkIcon: '/img/checkmark.svg',
        qrReaderLoading: true,
        result: null,
        loading: false,
        partner: {
            code: null,
            logo: null,
            name: null,
            address: null,
            city: null,
            country: null
        },
        labels: {
            code: 'Código',
            amount: 'Valor Recibido'
        },
        form: {
            id: 0,
            amount: 0
        },
        payment: {
            id: 0,
            sender: {
                mobile: null
            },
            receiver: {
                mobile: null,
                details: {
                    message1: null
                }
            },
            sname: null,
            sdocument: null,
            rname: null,
            rdocument: null,
            bank_info: null,
            office_info: null
        },
        currency_precision: 0
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'collectpage');
        this.getIni();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getIni();
        }
    },
    computed: {
        validationPending() {
            return this.isValid === undefined
                && this.camera === 'off';
        },
        validationSuccess() {
            return this.isValid === true;
        },
        validationFailure() {
            return this.isValid === false;
        }
    },
    methods: {
        getIni() {
            axios.get('/api/partner/pending').then((res) => {
                if (res.data.status === 'success') {
                    this.buy.items = res.data.items1;
                    this.buy.totalRows = this.buy.items.length;
                    this.pay.items = res.data.items2;
                    this.pay.totalRows = this.pay.items.length;
                    this.partner = res.data.partner;
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        openSale(id) {
            this.form = {
                id: 0,
                amount: 0
            };
            if (id) {
                const items = this.buy.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.payment = items[i];
                        this.form.id = items[i].id;
                    }
                }
            }
        },
        openPay(id) {
            this.form = {
                id: 0,
                amount: 0
            };
            if (id) {
                const items = this.pay.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.payment = items[i];
                        this.form.id = items[i].id;
                    }
                }
            }
        },
        getApprove(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/partner/approve', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        const items = this.buy.items;
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].id === id) {
                                items.splice( i, 1 );
                                this.buy.totalRows = this.buy.items.length;
                            }
                        }
                        setTimeout(this.print('ticket1'), 2000);
                    }
                    this.$bvModal.hide('sale');
                    this.$validator.reset();
                    this.openSale();
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        getComplete(id) {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                let formData = new FormData();
                formData.append('id', this.form.id);
                axios.post('/api/paymaster/complete', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        const items = this.pay.items;
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].id === id) {
                                items.splice( i, 1 );
                                this.pay.totalRows = this.pay.items.length;
                            }
                        }
                        setTimeout(this.print('ticket2'), 2000);
                    }
                    this.$bvModal.hide('pay');
                    this.$validator.reset();
                    this.openPay();
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        async onInit(promise) {
            try {
                await promise;
            } catch (e) {
                console.error(e);
            } finally {
                this.resetValidationState();
                this.qrReaderLoading = false;
            }
        },
        async onDecode(content) {
            this.result = content;
            this.turnCameraOff();

            await this.getID(content);
        },
        getID(v) {
            let id = null;
            let code = null;
            const md5 = require('md5');
            const items = this.buy.items;
            for (let i = 0; i < items.length; i++) {
                code = md5((items[i].id).toString());
                if (code === v) {
                    id = items[i].id;
                }
            }

            if (id) {
                this.isValid = true;
                this.openSale(id);
                setTimeout(this.reloadCamera, 2000);
                this.$bvModal.hide('qrReader');
                this.$bvModal.show('sale');
            } else {
                this.$root.$bvToast.toast('El ID de pago no ha sido encontrado.', {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'warning',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
                this.isValid = false;
                this.turnCameraOn();
                setTimeout(this.reloadCamera, 3000);
            }
        },
        turnCameraOn() {
            this.camera = 'auto';
        },
        turnCameraOff() {
            this.camera = 'off';
        },
        reloadCamera() {
            this.isValid = undefined;
        },
        print(id) {
            let printContents = document.getElementById(id).innerHTML;
            let w = window.open('_', 'Imprimir Voucher');
            w.document.write(printContents);
            w.document.close(); // necessary for IE >= 10
            w.onload=function () { // necessary if the div contain images
                w.focus(); // necessary for IE >= 10
                w.print();
                w.close();
            };
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
@media print {
    #ticket1, #ticket2 {}
}
@media screen {
    #ticket1, #ticket2 {
        display: none;
    }
}
.loading-indicator {
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
}
.validation-success,
.validation-failure,
.validation-pending {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, .8);
    text-align: center;
    font-weight: bold;
    font-size: 1.4rem;
    padding: 10px;
    border-radius: 12px;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
}
.validation-success {
    color: #28a745;
}
.validation-pending {
    color: #ff7900;
}
.validation-failure {
    color: #dd1717;
}
.validation-success img,
.validation-failure img,
.validation-pending img {
    width: 100%;
    height: 132px;
    padding-bottom: 12px;
}
.tab-content .tab-pane {
    box-shadow: none !important;
}
</style>
